import { useEffect, useState } from "react";
import "./maximetrohistorydrawer.css";
import { X, ChevronDown, ChevronUp } from "lucide-react";
import {
  getMaximeterHistory,
  getMaximeterByVersion,
} from "../../../redux/apiCalls/data/maximetroCall";
import { Toast } from "../../../helpers/alert";
import Swal from "sweetalert2";

const MaximetroHistoryDrawer = ({
  open,
  onClose,
  branchId,
  startDate,
  endDate,
  dispatch,
  token,
  onSelectVersion,
}) => {
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [expanded, setExpanded] = useState(null);

  useEffect(() => {
    if (!open) return;

    const fetchHistory = async () => {
      setLoading(true);
      try {
        const data = await getMaximeterHistory(
          token,
          startDate,
          endDate,
          branchId,
        );
        setRows(data);
      } catch (e) {
        Toast.fire({ icon: "error", title: "No se pudo cargar historial" });
        onClose();
      } finally {
        setLoading(false);
      }
    };

    fetchHistory();
  }, [open]);

  const reasonMap = {
    INITIAL: "Cálculo inicial",
    MANUAL_RECALC: "Recalculado manualmente",
  };

  if (!open) return null;

  return (
    <div className="mxDrawerOverlay" onClick={onClose}>
      <div className="mxDrawerPanel" onClick={(e) => e.stopPropagation()}>
        <div className="mxDrawerHeader">
          <div className="mxDrawerTitle">Historial de versiones</div>
          <button className="mxDrawerClose" onClick={onClose}>
            <X size={18} />
          </button>
        </div>

        <div className="mxDrawerBody">
          {loading && <p className="mxDrawerLoading">Cargando...</p>}

          {!loading && rows.length === 0 && (
            <p className="mxDrawerEmpty">No hay versiones registradas.</p>
          )}

          {!loading &&
            rows.map((row) => {
              const isExpanded = expanded === row.id;

              return (
                <div key={row.id} className="mxHistoryRow">
                  <div className="mxHistoryTop">
                    <div className="mxContInfoMeta">
                      <div className="mxHistoryInfo">
                        <span className="mxBadgeVersion">
                          v{row.version_number}
                        </span>

                        {row.is_current && (
                          <span className="mxCurrentInline">Vigente</span>
                        )}
                      </div>
                      <div className="mxHistoryMeta">
                        <span>{new Date(row.created_at).toLocaleString()}</span>
                        <span className="mxReason">{reasonMap[row.calculation_reason] || row.calculation_reason}</span>
                      </div>
                    </div>
                    <div className="mxHistoryActions">
                      <button
                        className="mxIconBtn"
                        onClick={() => setExpanded(isExpanded ? null : row.id)}
                      >
                        {isExpanded ? (
                          <ChevronUp size={18} />
                        ) : (
                          <ChevronDown size={18} />
                        )}
                      </button>

                      <button
                        className="mxBtnPrimary"
                        onClick={async () => {
                          try {
                            Swal.fire({
                              title: "Cargando versión...",
                              allowOutsideClick: false,
                              didOpen: () => Swal.showLoading(),
                            });

                            const data = await getMaximeterByVersion(
                              token,
                              startDate,
                              endDate,
                              branchId,
                              row.version_number,
                            );

                            Swal.close();
                            onSelectVersion(data);
                            onClose();
                          } catch (e) {
                            Swal.close();
                            Toast.fire({
                              icon: "error",
                              title: "No se pudo cargar versión",
                            });
                          }
                        }}
                      >
                        Ver
                      </button>
                    </div>
                  </div>

                  {isExpanded && (
                    <div className="mxHistoryDetail">
                      <p>
                        Demanda máxima: {row.measured_max_demand} kW
                      </p>
                      <p>
                        {new Date(row.timestamp_of_max_utc).toLocaleString()}
                      </p>
                    </div>
                  )}
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
};

export default MaximetroHistoryDrawer;
